const AUTOPILOT_HEALTH_STATUS_META = {
  healthy: {
    label: "Saudável",
    color: "var(--everlog-status-success)",
  },
  warning: {
    label: "Em atenção",
    color: "var(--everlog-status-warning)",
  },
  critical: {
    label: "Ação imediata",
    color: "var(--everlog-status-danger)",
  },
  neutral: {
    label: "Sem base",
    color: "var(--theme-accent)",
  },
};

function parseTaxa(value) {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function getFallbackStatus(taxa) {
  if (taxa === null || taxa === undefined) return "neutral";
  if (taxa >= 90) return "healthy";
  if (taxa >= 70) return "warning";
  return "critical";
}

function inferAverageTaxa(data) {
  const fronts = [
    { key: "frete", taxa: parseTaxa(data?.freteTaxa) },
    { key: "nf", taxa: parseTaxa(data?.nfTaxa) },
    { key: "cte", taxa: parseTaxa(data?.cteTaxa) },
    { key: "fatura", taxa: parseTaxa(data?.faturaTaxa) },
  ].filter((item) => item.taxa !== null);

  if (!fronts.length) return null;

  const average = fronts.reduce((acc, item) => acc + item.taxa, 0) / fronts.length;
  return Number(average.toFixed(1));
}

export function getAutopilotHealthSummary(data) {
  const taxa = parseTaxa(data?.healthTaxa) ?? inferAverageTaxa(data);
  const status = data?.healthStatus || getFallbackStatus(taxa);
  const meta = AUTOPILOT_HEALTH_STATUS_META[status] || AUTOPILOT_HEALTH_STATUS_META.neutral;

  return {
    taxa,
    status,
    statusLabel: meta.label,
    statusColor: meta.color,
  };
}

export function getAutopilotSummaryLine(answer) {
  if (!answer) return "";

  const line = answer
    .split("\n")
    .map((item) => item.trim())
    .find(Boolean);

  if (!line) return "";

  return line
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/\s{2,}/g, " ")
    .trim();
}
